// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "fb37f15bc6289d19740fcc76e84880093c0d566f/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};